export default __webpack_public_path__ + "static/media/module1.5c51410b.jpg";